import resolver, {ResolverSettings} from './utils/resolver';
import {GuestGroup, GuestGroupMembers, UpdateGuestGroup} from '../utils/types';

class GuestGroupApi {
  ENDPOINTS = {
    guestGroup: (id = '') => `guestapp/guest-group/${id ? `${id}/` : ``}`,
    members: (id = '') => `guest-groups/${id}/guests/`,
  };

  getGuestGroup(id: string, resolverSettings?: ResolverSettings) {
    return resolver<GuestGroup>(
      this.ENDPOINTS.guestGroup(id),
      {
        method: 'GET',
      },
      {version: 'v4', ...resolverSettings},
    );
  }

  patchGuestGroup(
    id: string,
    payload: UpdateGuestGroup,
    resolverSettings?: ResolverSettings,
  ) {
    return resolver<GuestGroup>(
      this.ENDPOINTS.guestGroup(id),
      {
        method: 'PATCH',
        body: JSON.stringify(payload),
      },
      {version: 'v4', ...resolverSettings},
    );
  }

  getGuestGroupMembers(id: string, resolverSettings?: ResolverSettings) {
    return resolver<GuestGroupMembers>(
      this.ENDPOINTS.members(id),
      {
        method: 'GET',
      },
      {version: 'v4', ...resolverSettings},
    );
  }
}

export {GuestGroupApi};
